import React from 'react';
import Markdown from '../markdown';
import styled from 'styled-components';

const NoteWrapper = styled.div`
  font-family: ${p => p.theme.serif};
  line-height: 1.5em;
  font-size: 16px;
  color: #666;
  font-weight: 300;
  align-items: center;
  background: ${props => (props.current ? 'lightyellow' : 'white')};
  padding: 1em;
  letter-spacing: 0.0125em;
`;

const ChapterNote = ({ isUnderCursor, note }) => {
  let text = note.body;
  if (note.head) {
    text = `**${note.head} –** ${text}`;
  }
  return (
    <NoteWrapper current={isUnderCursor}>
      <Markdown text={text} />
    </NoteWrapper>
  );
};

export default ChapterNote;
